import { BaseStore } from 'types';

export function baseStoreFactory(params: any = {}): BaseStore {
  const { pickUpConfiguration, storeShippingConfiguration, uid } = params;

  return {
    pickUpConfiguration: {
      radius: pickUpConfiguration?.radius || 0,
    },
    storeShippingConfiguration: {
      radius: storeShippingConfiguration?.radius || 0,
    },
    uid: uid || '',
  };
}
